module.exports = __webpack_public_path__ + "static/media/earn_video.50b183ad.mp4";